import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Pencil, Check, X, Save } from "lucide-react";

export default function Menu() {
  const [days, setDays] = useState([]);
  const [notes, setNotes] = useState("");
  const [notesDraft, setNotesDraft] = useState("");
  const [editNotes, setEditNotes] = useState(false);
  const [editDay, setEditDay] = useState(null);
  const [draft, setDraft] = useState({ main_dish: "", per_person_g: "", total_kg: "", rounded_kg: "", notes: "" });

  const load = async () => {
    try {
      const { data } = await api.get("/menu");
      setDays(Array.isArray(data?.days) ? data.days : []);
      setNotes(data?.notes || "");
      setNotesDraft(data?.notes || "");
    } catch (e) { console.error("Menu load:", e); }
  };
  useEffect(() => { load(); }, []);

  const startEdit = (d) => {
    setEditDay(d.day);
    setDraft({
      main_dish: d.main_dish || "",
      per_person_g: d.per_person_g || "",
      total_kg: d.total_kg || "",
      rounded_kg: d.rounded_kg || "",
      date_label: d.date_label || "",
      notes: d.notes || "",
    });
  };

  const saveDay = async () => {
    const body = {
      day: editDay,
      main_dish: draft.main_dish,
      per_person_g: parseFloat(String(draft.per_person_g).replace(",", ".")) || 0,
      total_kg: parseFloat(String(draft.total_kg).replace(",", ".")) || 0,
      rounded_kg: parseFloat(String(draft.rounded_kg).replace(",", ".")) || 0,
      date_label: draft.date_label || "",
      notes: draft.notes || "",
    };
    await api.put(`/menu/${editDay}`, body);
    setEditDay(null);
    await load();
  };

  const saveNotes = async () => {
    await api.put("/menu-notes", { text: notesDraft });
    setNotes(notesDraft);
    setEditNotes(false);
  };

  return (
    <div className="space-y-5">
      <div className="space-y-2">
        {days.map((d) => {
          const isEdit = editDay === d.day;
          return (
            <div key={d.day} data-testid={`menu-day-${d.day}`} className="tk-card p-4">
              {isEdit ? (
                <div className="grid grid-cols-1 md:grid-cols-5 gap-3">
                  <div className="md:col-span-5 text-sm font-display font-semibold">Gece {d.day}</div>
                  <div className="md:col-span-2">
                    <label className="tk-label">Ana Yemek</label>
                    <input data-testid={`menu-dish-input-${d.day}`} className="tk-input" value={draft.main_dish} onChange={(e) => setDraft({ ...draft, main_dish: e.target.value })} />
                  </div>
                  <div>
                    <label className="tk-label">Tarih</label>
                    <input data-testid={`menu-date-input-${d.day}`} className="tk-input" value={draft.date_label} onChange={(e) => setDraft({ ...draft, date_label: e.target.value })} placeholder="22 Ağu Cmt" />
                  </div>
                  <div>
                    <label className="tk-label">Kişi başı (gr)</label>
                    <input data-testid={`menu-per-person-input-${d.day}`} inputMode="decimal" className="tk-input" value={draft.per_person_g} onChange={(e) => setDraft({ ...draft, per_person_g: e.target.value })} />
                  </div>
                  <div>
                    <label className="tk-label">Toplam (kg)</label>
                    <input data-testid={`menu-total-input-${d.day}`} inputMode="decimal" className="tk-input" value={draft.total_kg} onChange={(e) => setDraft({ ...draft, total_kg: e.target.value })} />
                  </div>
                  <div>
                    <label className="tk-label">Yuvarlama (kg)</label>
                    <input data-testid={`menu-rounded-input-${d.day}`} inputMode="decimal" className="tk-input" value={draft.rounded_kg} onChange={(e) => setDraft({ ...draft, rounded_kg: e.target.value })} />
                  </div>
                  <div className="md:col-span-5">
                    <label className="tk-label">Not</label>
                    <input data-testid={`menu-note-input-${d.day}`} className="tk-input" value={draft.notes} onChange={(e) => setDraft({ ...draft, notes: e.target.value })} />
                  </div>
                  <div className="md:col-span-5 flex items-center justify-end gap-2">
                    <button data-testid={`menu-cancel-btn-${d.day}`} onClick={() => setEditDay(null)} className="tk-btn-ghost flex items-center gap-1.5"><X className="w-4 h-4" /> Vazgeç</button>
                    <button data-testid={`menu-save-btn-${d.day}`} onClick={saveDay} className="tk-btn flex items-center gap-1.5"><Check className="w-4 h-4" /> Kaydet</button>
                  </div>
                </div>
              ) : (
                <div className="flex items-start gap-3">
                  <div className="w-11 h-11 rounded-xl flex flex-col items-center justify-center flex-shrink-0" style={{ backgroundColor: "hsl(var(--surface-2))" }}>
                    <div className="text-[10px] uppercase tracking-widest" style={{ color: "hsl(var(--text-2))" }}>Gece</div>
                    <div className="text-lg font-display font-bold leading-none">{d.day}</div>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex flex-wrap items-center gap-2">
                      <div className="font-display font-semibold">{d.main_dish}</div>
                      {d.date_label && <span className="tk-chip" data-testid={`menu-date-chip-${d.day}`}>{d.date_label}</span>}
                    </div>
                    <div className="mt-1 flex flex-wrap gap-x-3 gap-y-1 text-sm" style={{ color: "hsl(var(--text-2))" }}>
                      <span>Kişi başı <b className="text-[hsl(var(--text-1))]">{d.per_person_g} gr</b></span>
                      <span>Toplam <b className="text-[hsl(var(--text-1))]">{d.total_kg} kg</b></span>
                      <span>Yuvarlama <b className="text-[hsl(var(--text-1))]">{d.rounded_kg} kg</b></span>
                    </div>
                    {d.notes && <div className="mt-1 text-xs" style={{ color: "hsl(var(--text-2))" }}>{d.notes}</div>}
                  </div>
                  <button data-testid={`menu-edit-btn-${d.day}`} onClick={() => startEdit(d)} className="tk-btn-ghost !py-2 !px-2.5"><Pencil className="w-4 h-4" /></button>
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="tk-card p-5" data-testid="menu-notes-card">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-lg font-display font-semibold">Notlar</h3>
          {editNotes ? (
            <div className="flex items-center gap-2">
              <button data-testid="menu-notes-cancel-btn" onClick={() => { setEditNotes(false); setNotesDraft(notes); }} className="tk-btn-ghost !py-2 !px-3 text-sm flex items-center gap-1.5"><X className="w-4 h-4" /> Vazgeç</button>
              <button data-testid="menu-notes-save-btn" onClick={saveNotes} className="tk-btn !py-2 !px-3 text-sm flex items-center gap-1.5"><Save className="w-4 h-4" /> Kaydet</button>
            </div>
          ) : (
            <button data-testid="menu-notes-edit-btn" onClick={() => setEditNotes(true)} className="tk-btn-ghost !py-2 !px-3 text-sm">Düzenle</button>
          )}
        </div>
        {editNotes ? (
          <textarea
            data-testid="menu-notes-textarea"
            className="tk-input min-h-[180px] font-mono text-sm leading-relaxed"
            value={notesDraft}
            onChange={(e) => setNotesDraft(e.target.value)}
          />
        ) : (
          <pre className="whitespace-pre-wrap text-sm leading-relaxed font-sans" style={{ color: "hsl(var(--text-2))" }}>
            {notes || "—"}
          </pre>
        )}
      </div>
    </div>
  );
}
